import utils from "./utils";
var resolveParams = function (params, extra) {
  var result = [];
  var timestamp = (extra && extra.timestamp) || 1 * new Date();
  var domainurl = document.referrer ? document.referrer : null;
  for (var a in params)
    a !== 'adddomain' && params.hasOwnProperty(a) && result.push(encodeURIComponent(a) + "=" + encodeURIComponent(params[a]));
  if(params.adddomain){
    return (
      extra && extra.sign && result.push("sign=" + extra.sign),
      result.push("time=" + timestamp),
      result.join("&"),
      result.push("domain=" + domainurl),
      result.join("&")
    )
  }else{
    return (
      extra && extra.sign && result.push("sign=" + extra.sign),
      result.push("time=" + timestamp),
      result.join("&")
    )
  }
};
const testDomain = window.location.host === "test.qunsou.co" || window.location.host === "localhost:1111";
const resovleDomain = (params) => {
  if (params.thirdDomain) {
    return;
  }
  params.url =
    (testDomain ? "https://test.qunsou.co" : "https://apiplugin.h5bqb.top") +
    params.url;
};
var a =
  "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
    ? function (e) {
        return typeof e;
      }
    : function (e) {
        return e &&
          "function" == typeof Symbol &&
          e.constructor === Symbol &&
          e !== Symbol.prototype
          ? "symbol"
          : typeof e;
      };
const httpRequest = (params) => {
  resovleDomain(params);
  params.type = (params.type || "GET").toUpperCase();
  params.dataType = params.dataType || "json";
  params.contentType =
    params.contentType || "application/x-www-form-urlencoded; charset=UTF-8";
  let httpMethod;
  if ("undefined" != typeof XMLHttpRequest) {
    httpMethod = new XMLHttpRequest();
  } else {
    for (
      let i = [
          "Microsoft.XmlHttp",
          "MSXML2.XmlHttp",
          "MSXML2.XmlHttp.3.0",
          "MSXML2.XmlHttp.4.0",
          "MSXML2.XmlHttp.5.0",
          "MSXML2.XmlHttp.6.0",
        ],
        o = 0,
        l = i.length;
      o < l;
      o++
    ) {
      try {
        httpMethod = new ActiveXObject(i[o]);
        break;
      } catch (c) {}
    }
  }
  httpMethod.onreadystatechange = function () {
    if (4 === httpMethod.readyState) {
      var status = httpMethod.status;
      if (status >= 200 && status < 300) {
        var res = httpMethod.responseText;
        try {
          "json" === params.dataType && res && (res = JSON.parse(res));
        } catch (c) {}
        if (res.sta == 0) {
          params.success && params.success(res, httpMethod.responseXML);
        } else {
          params.error && params.error(res);
        }
      } else {
        params.error && params.error(httpMethod.responseText);
      }
    }
  };
  if ("GET" === params.type) {
    httpMethod.open("GET", params.url + "?" + resolveParams(params.data), !0);
    httpMethod.send(null);
  } else if ("POST" === params.type) {
    httpMethod.open("POST", "" + params.url, !0);
    !params.fileType &&
      httpMethod.setRequestHeader("Content-Type", params.contentType);
    var u = params.header;
    if (u) {
      for (var f in u) {
        httpMethod.setRequestHeader(f, u[f]);
      }
    }
    var h = params.data;
    "object" === ("undefined" == typeof h ? "undefined" : a(h)) &&
      !params.fileType &&
      (h = JSON.stringify(h));
    httpMethod.send(h);
  }
  return params.beforeSend && params.beforeSend(httpMethod), httpMethod;
};
const changeInputImg = (token, files, base64, msgItem, cb) => {
  let curFile;
  let imgFile;
  if (base64) {
    curFile = files.blob;
    imgFile =
      curFile.type &&
      curFile.type.indexOf("image") > -1 &&
      curFile.type.indexOf("svg") < 0;
  } else {
    if (files.length == 0) {
      cb(600, { msg: "上传失败，请重新上传！"});
      return;
    }
    curFile = files[0];
    imgFile =
      curFile &&
      curFile.type &&
      curFile.type.indexOf("image") > -1 &&
      curFile.type.indexOf("svg") < 0;
    const videoFile = utils.isVideoFile(curFile.name)
    if ((!curFile || curFile.size > 25 * 1024 * 1024) && !videoFile) {
      cb(600, { msg: (imgFile ? "图片" : "文件") + "的大小不能超过25M！" });
      return;
    }
    if(videoFile && (!curFile || curFile.size > 30 * 1024 * 1024)){
      cb(600, { msg: "视频的大小不能超过30M！"});
      return;
    }
  }

  const data = new FormData();
  data.append("file", curFile);
  data.append("ftype", imgFile ? "image" : utils.isVideoFile(curFile.name) ? 'video' : "file");
  data.append("fsize", curFile.size);
  if(msgItem && msgItem.msgtype == "video" && msgItem.width == 0 && msgItem.height == 0){
    data.append("return_thumb", true);
  }

  let channel_id = utils.getParameterByName("channel_id");
  let client_id = utils.getParameterByName("client_id");
  let add_params = `&channel_id=${channel_id}&client_id=${client_id}&ftype=${imgFile ? "image" : utils.isVideoFile(curFile.name) ? 'video' : "file"}`
  httpRequest({
    type: "POST",
    url: "/wykf/api/v1/enterprise/webplugin/upload?version=0.0.9&token=" + token + add_params,
    data: data,
    fileType: true,
    success: (result) => {
      cb(0, result.data[0]);
    },
    error: (res) => {
      cb(-1, {
        msg: res.msg || (imgFile ? "图片" : utils.isVideoFile(curFile.name) ? "视频" : "文件") + "上传失败！",
        errcode: res.sta,
        token
      });
    },
  });
};
export default {
  httpRequest,
  changeInputImg,
  testDomain,
};


// WEBPACK FOOTER //
// ./src/js/ajaxutils.js